/*

RajeshK  09/19/2022 2700657555 Fixed GAL (136,137,158,98)
Sohel    09/20/2022 2700657555 Fixed GAL - 31,124,134,137,138,149,157,175
Ashraf   09/22/2022 2700657555 fixed value validation in subscribe popup, add role button disabling
Ashraf   10/16/2022 2700657555 added code comments in search, add user management
Akhlaque 10/26/2022 2700657555  renamed cancel button to reset
prakash 26/10/2022 2700657555 added classes for buttons.
ashraf 10/27/2022  2700657555  user management ux changes
Rohini 10/28/2022  2700657555  added searchuser button inside the grid
Lalitha 10/26/2022 2700657555  renamed cancel button to reset
Ashraf 10/30/2022  2700657555 fixed spell mistake of company code
Rohini 10/30/2022 2700657555  added classname for the table
Ashraf 11/15/2022 2700657555 Fixed existing username and email validation issue
Ashraf 12/07/2022  2700657555 fixed user login name field
Lalitha 12/09/2022 2700657555   Added reusable backButtonText
Lalitha 12/12/2022 2700657555   Added visibility icon with functionality
Ashraf 12/14/2022 2700657555  disabled user login name while edit
Sai Maheshwar 12/14/2022 3031450488 added save close for add user
Ashraf 12/15/2022 3031450488 fixed role based access
Ashraf 12/19/2022 3031450488 validation for duplicate user names restrictions
Suresh Peddavoora 12/21/2022 3031450488 Fixed Validation Alignment Issue for Text Field
Prakash 12/22/2022 2700657555 Removed card component.
prakash 12/27/2022 2700657555 fixed alignments issue for inputfield.
dilip 12/29/2022 2700657555 disabled is active while adding new user
dilip 12/29/2022 2700657555 added white space not allowed validation for user name
Ashraf 01/31/2022 2700657555 enabled add role button on isActive
suresh peddavoora 02/24/2023 2700657555 New UI changes added
suresh peddavoora 02/27/2023 2700657555 New UI changes
suresh peddavoora 03/01/2023 2700657555 New UI changes
//suresh peddavoora 03/03/2023 2700657555 Tables and fields alignments
sohel 3/6/2023 2700657555 added validation for user name
sohel 03/06/2023 2700657555 Added validation message for existing value
suresh peddavoora 03/14/2023 2700657555 Tables and fields alignments
prakash 03/15/2023 2700657555 fixed alignments issue in responsive
suresh peddavoora 04/06/2023 2700657555 fields alignment fixes
Ravi 05/18/2023 2700657555 fixed validation issue in user Name
Ravi 06/05/2023 2700657555 fixed validation issue in user login Name
Akhila 06/05/2023 2700657555 unsaved changes bug fixed/implemented
Ravi 06/20/2023 2700657555 Added Breadcrum in popup
Ravi 06/26/2023 2700657555 fixed submit issue
Sohel 10/20/2023 2700657555 Fixed User Login Name Validation Issue
Sohel 10/20/2023 2700657555 Added new Fields
dilip-pds 10/26/2023 2700657555 Added validation in phone number
*/

import {
  Grid,
  TextField,
  Button,
  FormHelperText,
  FormControl,
  FormControlLabel,
  Checkbox,
  Typography,
  Tooltip,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useEffect, useState, useContext} from 'react';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import DialogBox from '../../../components/DialogBox';
import {
  postAddUserData,
  postEditUserData,
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
  fetchAllUserEmailsAndNames,
} from '../../../redux/reducers/UserManagement/AddUser';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import * as Yup from 'yup';
import RolesTable from './RolesTable';
import AddIcon from '@material-ui/icons/Add';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import {getOptions} from '../../../util/GetDropDownOptions';
import {COMPANY_TYPE} from '../../../constants/Lookup';
// import {makeStyles} from '@material-ui/styles';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {ArrowBack, Visibility, VisibilityOff} from '@material-ui/icons';
import {backButtonText} from '../../../util/Content';
import {PhoneMaskCustom} from '../../../util/PhoneMaskFormat';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import SearchRoleManagement from '../../RoleManagement/SearchRoleManagement/SearchRoleManagement';
import {reportMasterUserName} from '../../../redux/reducers/BRE/AddReportMaster';
// import {whiteSpaceRegEx} from '../../../util/RegexPatterns';
import {setAlertData} from '../../../redux/reducers/UnsavedChangesAlertReducer';
import BreadCrums from '../../../util/BreadCrum';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;


// to create a new user (2700657555)
const AddUser = ({
  setValue,
  selected,
  value,
  companyCode,
  setCompanyCode,
  handleDirty,
  showAlertRef,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {addUserStatus, putUserStatus, isLoading, errorMsg, successMsg, addUserData, allUserEmailsAndNames} =
    useSelector(({addUser}) => addUser);
  const [company, setCompany] = useState([]);
  // const {userNameData} = useSelector(({addReportMaster}) => addReportMaster);
  // fetch all user email and names dropdown (2700657555)
  useEffect(() => {
    dispatch(fetchAllUserEmailsAndNames());
    dispatch(reportMasterUserName());
  }, []);

  const {roleData} = useSelector(({role}) => role);
  // const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  // states used for prepopulating company code dropdown field (2700657555)
  useEffect(() => {
    setCompanyCode(addUserData?.companyCode);
    setCompany(addUserData?.companyCode);
  }, [addUserData]);

  const {companyCodeData} = useSelector(({addLetterData}) => addLetterData);
  const [openWindow, setOpenWindow] = useState(false);
  const [roleValues, setRoleValues] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confPasswordShown, setConfPasswordShown] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  // used to get an object from set of objects, for company code initial value (2700657555)
  const getObjectModule = (options, option) => {
    const mappedCustomerCode = option?.map((optionNum) => {
      for (const object2 in options) {
        if (options[object2]?.value === optionNum) {
          return {
            value: options[object2]?.value,
          };
        }
      }
    });
    return mappedCustomerCode;
  };

  // initial values for add user form (2700657555)
  const initialValues = {
    userFullName: addUserData?.userName || '',
    firstName: addUserData?.firstName || '',
    lastName: addUserData?.lastName || '',
    phoneNumber: (addUserData?.phoneNumber || '').replace(/\+/g, ''),
    userName: addUserData?.emailId || '',
    emailId: addUserData?.emailId || '',
    isActive: addUserData?.isActive !== 'N',
    password: '',
    confirmPassword: '',
    role: '',
    departmentDivision: addUserData?.departmentDivision || '',
    companyCode:
      companyCode?.length > 0 ?
        getObjectModule(getOptions(COMPANY_TYPE, companyCodeData), companyCode) :
        [],
    location: addUserData?.location || '',
  };

  // checking if entered email already exist in fetched all user emails data (2700657555)
  const checkEmailExist = (value) => {
    if (allUserEmailsAndNames && allUserEmailsAndNames?.length > 0 && value) {
      const ar = [];
      allUserEmailsAndNames.filter((i) => {
        if (
          i?.emailId?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const checkEmailAlreadyExist = (value) => {
    if (allUserEmailsAndNames && allUserEmailsAndNames?.length > 0 && value) {
      const ar = [];
      allUserEmailsAndNames.filter((i) => {
        if (
          i?.emailId?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  // checking if entered user name already exist in fetched all user name data (2700657555)
  /* const checkUserNameExist = (value, type) => {
    if (allUserEmailsAndNames && allUserEmailsAndNames?.length > 0 && value) {
      const ar = [];
      // let check = type === "userLoginName" ? "userLoginName" : "userName";
      allUserEmailsAndNames.filter((i) => {
        // if ((i?.[type]?.toLowerCase()?.replaceAll(" ", "") === value?.toLowerCase()?.replaceAll(" ", "")) && i?.isActive === "Y" ) {
        if (
          i?.[type]?.toLowerCase()?.replaceAll(' ', '') ===
          value?.toLowerCase()?.replaceAll(' ', '')
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  }; */
  /* const checkUserNameAlreadyExist = (value, type) => {
    if (allUserEmailsAndNames && allUserEmailsAndNames?.length > 0 && value) {
      const ar = [];
      // let check = type === "userLoginName" ? "userLoginName" : "userName";
      allUserEmailsAndNames.filter((i) => {
        // if ((i?.[check]?.toLowerCase()?.replaceAll(" ", "") === value?.toLowerCase()?.replaceAll(" ", "")) && i?.isActive === "N") {
        if (
          i?.[type]?.toLowerCase()?.replaceAll(' ', '') ===
          value?.toLowerCase()?.replaceAll(' ', '')
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  }; */
  // validations for add user form fields (2700657555)
  const schema = Yup.object().shape({
    /* userName: Yup.string()
      .matches(
        /^[a-zA-Z0-9@]+$/,
        'User Login Name cannot contain white space and special character',
      )
      .test('userName', 'User Login Name already exist', (value) =>
        value?.toLowerCase() === addUserData?.userLoginName?.toLowerCase() ?
          true :
          !checkUserNameExist(value, 'userLoginName'),
      )
      .test('userName', 'User Login Name has already been used in the past', (value) =>
        value?.toLowerCase() === addUserData?.userLoginName?.toLowerCase() ?
          true :
          !checkUserNameAlreadyExist(value, 'userLoginName'),
      )
      .required('User Login Name is required'), */
    // userFullName: Yup.string()
    //   .matches(whiteSpaceRegEx, "User name cannot start with white space")
    //   .matches(/^[a-zA-Z ]+$/, "User name cannot contain special character and numerics")
    //   // .test("userFullName", "User name already exist", (value) => value?.toLowerCase() === 
    // addUserData?.userName?.toLowerCase() ? true : !checkUserNameExist(value, "userName"))
    //   // .test("userFullName", "User name has already been used in the past", (value) =>
    // value?.toLowerCase() === addUserData?.userName?.toLowerCase() ? true : !checkUserNameAlreadyExist(value, "userName"))
    //   .required("User name is required"),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    emailId: Yup.string()
      .email('Invalid email format')
      .test('emailId', 'User Login Email already exist', (value) =>
        value?.toLowerCase() === addUserData?.emailId?.toLowerCase() ?
          true :
          !checkEmailExist(value),
      )
      .test('emailId', 'User Login Email has already been used in the past', (value) =>
        value?.toLowerCase() === addUserData?.emailId?.toLowerCase() ?
          true :
          !checkEmailAlreadyExist(value),
      )
      .required('User Login Email is required'),
    password:
      !selected &&
      Yup.string()
        .required('Please enter your password')
        .matches(
          /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
          'Password must contain at least 8 characters, one uppercase, one lower case, one numeric and one special case character',
        ),
    confirmPassword:
      !selected &&
      Yup.string()
        .required()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password is required'),
    companyCode: Yup.mixed().test('companyCode', 'Company code is required', (value) => {
      if (value?.length > 0 || value?.companyCode) {
        return true;
      } else {
        return false;
      }
    }),
    phoneNumber: Yup.string()
      .required('Phone Number is required')
      .test('phoneNumber', 'Invalid Phone Number', (value) => {
        if (!value) return false;
        value = value.replace(/[^\d]/g, '');
        return /^(\d)(?!\1+$)\d{9}$/.test(value);
      }),
  });

  // reset redux state on successful user data save or error state change (2700657555)
  useEffect(() => {
    if (addUserStatus === 200 || putUserStatus ===200 || errorMsg) {
      setTimeout(() => {
        dispatch(resetStatus());
        dispatch(resetMessage());
        setValue(0);
      }, 2000);
    }
  }, [addUserStatus, putUserStatus, errorMsg]);

  // prepopulating role table data for a particular user (2700657555)
  useEffect(() => {
    if (addUserData && addUserData?.roleId) {
      const fetchedTableData = addUserData?.roleId.map((i) => {
        return {
          ...i,
          roleDescription: i?.roleDescription,
          roleId: i?.roleId,
          roleName: i?.roleName,
          tableData: {checked: true, id: i?.roleId},
        };
      });
      // setFetchedData(fetchedTableData);
      setSelectedRows(fetchedTableData);
    }
  }, [addUserData]);

  // when role selection changes, storing that roles id in a state for save api payload (2700657555)
  useEffect(() => {
    const roleValues = selectedRows.map((i) => i?.roleId);
    setRoleValues(roleValues);
  }, [selectedRows]);

  // add or update a user save api (2700657555)
  const handleSubmit = (values) => {
    const phone = values?.phoneNumber ? (values?.phoneNumber.replace(/[^\d]/g, '')) : '';

    const getCompanyCodes =
      values?.companyCode?.length > 0 ? values.companyCode.map(item => item.value).join('_') : ''; 
    dispatch(submissionStart());
    if(addUserData?.userId){
      const currentMonth = new Date().toLocaleString('default', { month: 'short' });
      const currentYear = new Date().getFullYear();
      const token = `beatrix${currentMonth}${currentYear}`;
      const passValues = {
        target: values.emailId.trim(),
        token: token,
        isAdmin: true,
        attributes: {
          // id: addUserData?.id || 0,
          // userId: addUserData?.userId || 0,
          // emailId: values.emailId.trim(),
          first_name: values?.firstName ? values?.firstName : '',
          last_name: values?.lastName ? values?.lastName : '',
          phone_number: phone,
          company_code: getCompanyCodes || '',
          // departmentDivision: values.departmentDivision?.trim() || '',
          user_location: values.location?.trim() || '',
          roles: roleValues
        }
      };
      dispatch(postEditUserData(passValues));
    }else {
      const passValues = {
        userName: values?.firstName?.trim() + ' ' + values?.lastName?.trim(),
        userLoginName: values.emailId.trim(),
        firstName: values?.firstName ? values?.firstName : '',
        lastName: values?.lastName ? values?.lastName : '',
        phoneNumber: phone,
        roleId: roleValues,
        deletedRoleId: deletedIds,
        isActive: values.isActive ? 'Y' : 'N',
        emailId: values.emailId.trim(),
        password: values.password.trim(),
        confirmPassword: values.confirmPassword.trim(),
        userId: addUserData?.userId || 0,
        id: addUserData?.id || 0,
        companyCode: getCompanyCodes || '',
        departmentDivision: values.departmentDivision.trim(),
        location: values.location.trim(),
      };
      dispatch(postAddUserData(passValues));
    }
    handleDirty(false, 'reset');
  };

  // if company code is not selected, clear role assigned to that user (2700657555)
  useEffect(() => {
    if (company?.length === 0) {
      setSelectedRows([]);
    }
  }, [company]);

  // opens add role popup (2700657555)
  const handleWindowClose = () => {
    setOpenWindow(false);
  };

  // reset all data when clicked on reset button (2700657555)
  const handleReset = () => {
    if (addUserData && addUserData?.roleId) {
      setCompany(addUserData?.companyCode);
      const fetchedTableData = addUserData?.roleId.map((i) => {
        return {
          ...i,
          roleDescription: i?.roleDescription,
          roleId: i?.roleId,
          roleName: i?.roleName,
          tableData: {checked: true, id: i?.roleId},
        };
      });
      // setFetchedData(fetchedTableData);
      setSelectedRows(fetchedTableData);
    } else {
      setSelectedRows([]);
    }
  };
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const toggleConfPassword = () => {
    setConfPasswordShown(!confPasswordShown);
  };

  const getTooltipTitle = () => {
    if (!company || company.length === 0) {
      return "Please Select Company Code";
    }
    return "";
  };
  return (
    <div>
      <div className="">
        <Formik
          onSubmit={(values) => {
            handleSubmit(values);
          }}
          initialValues={initialValues}
          enableReinitialize
          validationSchema={schema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              resetForm,
              touched,
              errors,
              setFieldValue,
              dirty,
            } = props;
            if (dirty) {
              handleDirty(true);
            }
            return (
              <div>
                <Form noValidate autoComplete="off">
                  <div className="new-standard-textfields">
                    <div className="button-table-spacing-mb justify-content-start">
                      <Button
                        variant="outlined"
                        type="button"
                        className={`search-btn`}
                        onClick={() => {
                          // setValue(0);
                          if (showAlertRef.current) {
                            dispatch(
                              setAlertData({
                                showAlert: showAlertRef.current,
                                alertCallback: () => {
                                  setValue(0);
                                },
                              }),
                            );
                          } else {
                            setValue(0);
                          }
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        {backButtonText}
                      </Button>
                    </div>
                    <ErrorBoundaryForComponents>
                      <Grid
                        container
                        spacing={2}
                        className="adduser-management global-field-textfields new-standard-textfields"
                      >
                        <>
                          <Grid item xs={6} sm={6} md={4} lg={4} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter First Name`}
                              label="First Name"
                              className={` ${classes.labelName}`}
                              name="firstName"
                              value={values.firstName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                              required
                              error={Boolean(touched?.firstName && errors.firstName)}
                            />
                            <FormHelperText>
                              {touched?.firstName && errors.firstName}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={6} sm={6} md={4} lg={4} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Last Name`}
                              label="Last Name"
                              className={` ${classes.labelName}`}
                              name="lastName"
                              value={values.lastName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                              required
                              error={Boolean(touched?.lastName && errors.lastName)}
                            />
                            <FormHelperText>{touched?.lastName && errors.lastName}</FormHelperText>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={4}
                            lg={4}
                            
                          >
                            
                          </Grid>
                          <Grid item xs={6} sm={6} md={4} lg={4} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter User Login Email`}
                              label="User Login Email"
                              className={` ${classes.labelName}`}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              name="emailId"
                              value={values.emailId}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              disabled={values?.emailId === addUserData?.emailId}
                              fullWidth
                              required
                              error={Boolean(touched?.emailId && errors?.emailId)}
                            />
                            <FormHelperText>{touched?.emailId && errors?.emailId}</FormHelperText>
                          </Grid>
                          {/* <Grid item xs={6} sm={6} md={4} lg={4} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter User Name`}
                              label="User Name"
                              className={` ${classes.labelName}`}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              name="userFullName"
                              value={values.userFullName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                              disabled={addUserData?.isActive === 'N'}
                              required
                              error={Boolean(touched?.userFullName && errors.userFullName)}
                            />
                            <FormHelperText>
                              {touched?.userFullName && errors.userFullName}
                            </FormHelperText>
                          </Grid> */}
                          <Grid item xs={6} sm={6} md={4} lg={4} className="form-group">
                            <TextField
                              className={`${classes.labelName}`}
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Phone Number`}
                              label="Phone Number"
                              name="phoneNumber"
                              required
                              value={values?.phoneNumber}
                              onChange={(e) => {
                                setFieldValue('phoneNumber', e.target.value);
                              }}
                              onBlur={handleBlur}
                              InputProps={{
                                inputComponent: PhoneMaskCustom,
                              }}
                              fullWidth
                              error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                            /> 
                            <FormHelperText >
                              {errors?.phoneNumber && touched.phoneNumber ? errors?.phoneNumber : ''}
                            </FormHelperText>
                          </Grid>
                          {!selected && (
                            <>
                              <Grid
                                item
                                xs={6}
                                sm={6}
                                md={4}
                                lg={4}
                                className={`${
                                  errors?.password?.length > 40 ?
                                    'adduser-password-fields' :
                                    'error-password'
                                }`}
                              >
                                <TextField
                                  type={passwordShown ? 'text' : 'password'}
                                  margin="dense"
                                  variant="outlined"
                                  placeholder={`Enter Password`}
                                  label="Password"
                                  className={` ${classes.labelName}`}
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  name="password"
                                  value={values.password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  fullWidth
                                  required
                                  error={Boolean(touched.password && errors.password)}
                                  InputProps={{
                                    // <-- This is where the toggle button is added.
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          className="visibility-icon mb-3"
                                          aria-label="toggle password visibility"
                                          onClick={togglePassword}
                                        >
                                          {passwordShown ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <FormHelperText>
                                  {touched.password && errors?.password}
                                </FormHelperText>
                              </Grid>
                              <Grid item xs={6} sm={6} md={4} lg={4} className="form-group">
                                <TextField
                                  type={confPasswordShown ? 'text' : 'password'}
                                  margin="dense"
                                  variant="outlined"
                                  placeholder={`Confirm Password `}
                                  label="Confirm Password"
                                  className={` ${classes.labelName}`}
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  name="confirmPassword"
                                  value={values.confirmPassword}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  fullWidth
                                  required
                                  error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                                  InputProps={{
                                    // <-- This is where the toggle button is added.
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          className="visibility-icon mb-3"
                                          aria-label="toggle password visibility"
                                          onClick={toggleConfPassword}
                                        >
                                          {confPasswordShown ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <FormHelperText>
                                  {touched.confirmPassword && errors.confirmPassword}
                                </FormHelperText>
                              </Grid>
                            </>
                          )}
                          <Grid
                            item
                            xs={6}
                            md={4}
                            lg={4}
                            className={`form-group add autocomplete-field ${
                              value === 1 && touched.password ?
                                errors?.password?.length > 28 && 'validation-Space' :
                                null
                            } ${values.companyCode.length > 1 && 'autocomplete-checkbox'}`}
                          >
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                                popper: classes.popper,
                              }}
                              disableCloseOnSelect
                              className={` ${classes.labelName}`}
                              limitTags={1}
                              name="companyCode"
                              multiple
                              id="companyCode"
                              size="small"
                              value={values.companyCode}
                              // disabled={addUserData?.isActive === 'N'}
                              options={getOptions(COMPANY_TYPE, companyCodeData)}
                              getOptionSelected={(option, value) => option?.value === value?.value}
                              getOptionLabel={(option) => {
                                return option && option.value ? option.value : '';
                              }}
                              onChange={(e, value) => {
                                setFieldValue('companyCode', value);
                                if (value) {
                                  const getValue =
                                    value?.length > 0 ? value?.map((item) => item?.value) : [];
                                  setCompany(getValue);
                                }
                              }}
                              placeholder="Select Company Code"
                              renderOption={(option, {selected}) => (
                                <React.Fragment>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={
                                      <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                    }
                                    checked={selected}
                                    className={classes.checkBox}
                                  />

                                  {option?.value ? option.value : ''}
                                </React.Fragment>
                              )}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    className={` autocomplete-multiselect-label placeholder-filed`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    required
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off',
                                    }}
                                    label="Company Code"
                                    placeholder="Select Company Code"
                                    error={Boolean(touched.companyCode && errors.companyCode)}
                                  />
                                </div>
                              )}
                            />
                            <FormHelperText>
                              {touched.companyCode && errors && errors.companyCode}
                            </FormHelperText>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={4}
                            lg={4}
                            className={`form-group ${
                              value === 1 && touched.password ?
                                errors?.password?.length > 28 && 'validation-Space' :
                                null
                            }`}
                          >
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Location`}
                              label="Location"
                              className={` ${classes.labelName}`}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              name="location"
                              value={values.location}
                              // disabled={addUserData?.isActive === 'N'}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={4}
                            lg={4}
                            className={`form-group admin-checkbox ${
                              value === 1 && touched.password ?
                                errors?.password?.length > 28 && 'validation-Space' :
                                null
                            } mb-0`}
                          >
                            <FormControl margin="dense">
                              <FormControlLabel
                                className={classes.checkRoot}
                                control={
                                  <Checkbox
                                    onChange={handleChange}
                                    name="isActive"
                                    checked={values.isActive}
                                  />
                                }
                                label="Is Active"
                                labelPlacement="end"
                                disabled={!addUserData}
                              />
                            </FormControl>
                          </Grid>
                        </>
                      </Grid>
                    </ErrorBoundaryForComponents>
                    <div>
                      <div className="table-header table-card-header mt-2">
                        <Typography variant="h4" className="ml-2">
                          Roles
                        </Typography>
                        <Tooltip title={getTooltipTitle()}>
                          <span>
                            <Button
                              variant="outlined"
                              className={`search-btn ${classes.buttonRoot}`}
                              disabled={
                                !company ||
                                company?.length === 0 ||
                                !roleData?.window?.['User Management']?.UM?.add ||
                                !roleData?.window?.['User Management']?.UM?.edit
                              }
                              onClick={() => {
                                setOpenWindow(true);
                              }}
                            >
                              <AddIcon />
                              Add Role
                            </Button>
                          </span>
                        </Tooltip>
                      </div>
                      <RolesTable
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        deletedIds={deletedIds}
                        setDeletedIds={setDeletedIds}
                        handleDirty={handleDirty}
                      />
                    </div>

                    <div className="row justify-content-center mt-3 new-standard-textfields">
                      <Button
                        variant="outlined"
                        className={`mr-1 reset-btn ${classes.buttonRoot}`}
                        onClick={() => {
                          resetForm();
                          handleReset();
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`ml-1 search-btn ${classes.buttonRoot}`}
                        disabled={
                          !roleData?.window?.['User Management']?.UM?.add ||
                          !roleData?.window?.['User Management']?.UM?.edit ||
                          selectedRows?.length === 0
                        }
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                  {isLoading && <PageLoader />}
                  {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
                  {successMsg && <SuccessSnackbar successMsg={successMsg} />}
                </Form>
              </div>
            );
          }}
        </Formik>
        <DialogBox
          maxWidth="lg"
          open={openWindow}
          dialogClose={handleWindowClose}
          // title="Add Role"
          title={
            <div className="dialog-breadcrum">
              <p className="dialoge-title-breadcrum">
                <b>Add Role</b>
              </p>
              <BreadCrums
                name={'User Login Email'}
                code={addUserData?.emailId}
                description={'User Name'}
                descriptionValue={addUserData?.userName}
              />
            </div>
          }
        >
          <SearchRoleManagement
            isAddUser={true}
            tempSelectedRows={tempSelectedRows}
            handleClose={handleWindowClose}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            setTempSelectedRows={setTempSelectedRows}
            // fetchedData={fetchedData}
            setDeletedIds={setDeletedIds}
            company={company}
          />
          {/* <SearchRoleManagement
            setRoleValues={setRoleValues}
            roleValues={roleValues}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            deletedIds={deletedIds}
            setDeletedIds={setDeletedIds}
            fetchedData={fetchedData}
            company={company}
          /> */}
        </DialogBox>
      </div>
    </div>
  );
};

export default AddUser;
